import axios from "axios";// 导入axios
import elementUI from "element-ui";
import {WHITE_IP} from "../../public/config";

/*1、配置后台请求接口*/
/*创建了一个名为$http的axios实例，用于发送HTTP请求。*/
const $http = axios.create({  //在Vue的原型上添加一个$http属性，该属性保存了axios
    baseURL: `https://${WHITE_IP}`, timeout: 50000  // 50秒才超时
})

/*2、请求拦截器，对发送请求钱做一些处理，比如统一加token/对请求参数统一加密等...*/
/*配置了请求拦截器，在发送请求前添加了一些自定义的处理逻辑，如设置请求头中的Content-Type和token。*/
$http.interceptors.request.use(config => {
    config.headers['Content-Type'] = "application/json;charset=utf-8"  // 定义网络文件的类型和网页的编码，决定文件接收方将以什么形式、什么编码读取这个文件

    // 从本地存储拿，设置请求头！！！！！！！！！！！！
    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
    if (user) {
        config.headers['token'] = user.token; // 设置
    }

    return config
})

/*3、响应拦截器，在接口响应后统一处理结果*/
/*配置了响应拦截器，在接收到响应后根据响应的状态码进行相应的处理，如显示错误消息。*/
$http.interceptors.response.use(res => {
    //alert(JSON.stringify(res))
    if (res.data.code === "401") {
        elementUI.Message({
            message: res.data.message, type: "error"
        })
    }
    return res;
})

/*最后将$http对象导出，供其他模块使用。*/
export default $http
